import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ShieldCheckIcon, KeyIcon, GlobeIcon, FileCheckIcon, FingerprintIcon } from 'lucide-react';
const SecurityItem = ({
  icon,
  title,
  description,
  index
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
  index: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true
}} transition={{
  duration: 0.5,
  delay: index * 0.1
}} className="flex items-start gap-3 sm:gap-4" data-id="element-992">
    <div className="mt-1 text-orange-500 flex-shrink-0" data-id="element-993">{icon}</div>
    <div data-id="element-994">
      <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-1" data-id="element-995">
        {title}
      </h3>
      <p className="text-gray-600 text-sm leading-relaxed" data-id="element-996">{description}</p>
    </div>
  </motion.div>;
const SecurityGovernance = () => {
  return <section className="w-full bg-gradient-to-b from-white via-orange-50/20 to-white py-16 sm:py-24 md:py-32 lg:py-48" id="security" data-id="element-997">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-998">
        <div className="max-w-4xl mx-auto mb-12 sm:mb-14 md:mb-16 text-center" data-id="element-999">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 tracking-tight leading-tight" data-id="element-1000">
            Enterprise-grade security. Built in.
          </h2>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10 md:gap-12" data-id="element-1001">
          <SecurityItem index={0} icon={<ShieldCheckIcon size={20} className="sm:w-6 sm:h-6" data-id="element-1003" />} title="SOC 2 Type II in progress" description="Security program aligned with SOC 2 controls." data-id="element-1002" />
          <SecurityItem index={1} icon={<KeyIcon size={20} className="sm:w-6 sm:h-6" data-id="element-1005" />} title="Role-based access (RBAC)" description="Agents can only do what the user can do — enforced at the platform level." data-id="element-1004" />
          <SecurityItem index={2} icon={<LockIcon size={20} className="sm:w-6 sm:h-6" data-id="element-1007" />} title="Encryption" description="Encrypted in transit and at rest. We never train on your data." data-id="element-1006" />
          <SecurityItem index={3} icon={<GlobeIcon size={20} className="sm:w-6 sm:h-6" data-id="element-1009" />} title="Data residency" description="Regional hosting options to meet compliance requirements." data-id="element-1008" />
          <SecurityItem index={4} icon={<FileCheckIcon size={20} className="sm:w-6 sm:h-6" data-id="element-1011" />} title="Audit logs" description="Comprehensive logs of agent actions, tool calls, and decisions." data-id="element-1010" />
          <SecurityItem index={5} icon={<FingerprintIcon size={20} className="sm:w-6 sm:h-6" data-id="element-1013" />} title="SSO / SAML" description="Integrate with your identity provider for secure authentication." data-id="element-1012" />
        </div>
      </div>
    </section>;
};
export default SecurityGovernance;